import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 7h5.5v12h3V7H19V4H5z"
}), 'TitleTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TitleTwoTone.js
// module id = 6838
// module chunks = 2